/**
 *  PRODUCT PAGE
 *
 *  - login component init (after Express checkout initialization complete)
 *  - store selection
 *  - favorite store
 *  - click and collect for monosku product
 *
 *  This file should be renamed and/or it's functions should be dispateched on others
 *  The "favorite store" / store URL part should also be managed in backend
 */
import ui from '@/modules-es5/commons/lib/lib-ui';

let loginComponent = null;

export function init() {
  /* eslint-disable global-require */
  loginComponent = require('../../modules-es5/authentication/login/login'); // TODO : migrate to ES6
  /* eslint-enable global-require */

  // Init login component on express checkout ready //
  document.on('expressReady', () => {
    if (cube.$id('login-form')) loginComponent.init();

    if($('.selectpicker').length > 0) {
      $('.selectpicker').selectpicker('refresh');
    }

    if (cube.$('.cart-buttons--online .cta-v2--disabled')) {
      cube
        .$$('.js-move-to-regular-checkout')
        .classList.add('dkt-express-checkout-footer-change--invisible');
    }
  });

  // Set store Url in js-favorite-store input (which hold informations about the store)
  if (cube.$('.js-favorite-store')) {
    let storeUrl = '#';
    const storeDropdown = cube.$('#dropdown-find-store');

    if (storeDropdown.$('.visit-store-page'))
      // NAV V1 activated vs NAV V2 activated
      storeUrl = storeDropdown.$('.visit-store-page').href;
    else if (storeDropdown.classList.contains('navigation-store'))
      storeUrl = storeDropdown.href;

    cube.$('.js-favorite-store').dataset.url = storeUrl; //set the store

    // Click and Collect (monoSKU product) : "contact us" link if monoSKU product unavailable in favorite store
    if (cube.$('.buying-zone__unavail-cnc-message [href="#"]'))
      cube.$('.buying-zone__unavail-cnc-message [href="#"]').href = storeUrl;
  }
  if (cube.$('.link-composition.goTo')) {
    cube.$('.link-composition.goTo').addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const offset =
        65 +
        (cube.$('.description-product-nav__layout')
          ? cube.$('.description-product-nav__layout').offsetHeight
          : 0);
      ui.smoothScroll($('#ConceptandTechnologyFloor').offset().top - offset);
    });
  }
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/product-details.js